export default [
  {
    path: '/order',
    name: 'order',
    meta: {
      title: '我的订单'
    },
    component: () => import('@/views/order')
  }
]
